/* ==========================================================================
   BSC Academy — bootstrap GSAP · v2 · 25/08/2026

   ⚠️ PERCHE QUESTO E UN FILE E NON UNO <script> INLINE.
   Prima stava inline con l'attributo `defer`. Ma **`defer` su uno script
   inline non esiste**: lo standard lo ignora, e quel codice partiva subito,
   durante il parsing — cioe PRIMA che gsap.min.js e i plugin (quelli si,
   `defer` veri) avessero girato. `registerAll()` trovava `gsap` undefined,
   usciva, e `_flush()` non veniva mai chiamato: la coda di WS_GSAP.ready()
   restava piena per sempre e NESSUNA animazione a scroll partiva mai.
   Non si notava perche il degrado e silenzioso per costruzione: chi non si
   anima resta visibile. → Errori_e_soluzioni §0.1.15

   Da file esterno con `defer` l'ordine e garantito dallo standard: gli
   script differiti girano in ordine di documento, quindi core → plugin →
   questo. Il dato `WS_GSAP_BOOT` resta inline nel Liquid (deve essere
   generato da Liquid) e girando durante il parsing arriva comunque prima.
   ========================================================================== */

/*
  BOOTSTRAP — gira dopo core e plugin (tutti `defer`, quindi in ordine di
  documento e prima di DOMContentLoaded):
    - registra SOLO i plugin realmente definiti (filtro typeof);
    - aggancia il bridge theme editor (cleanup trigger morti + refresh);
    - refresh quando i webfont sono pronti;
    - sblocca la coda WS_GSAP.ready().
  Nessun ramo di failover: i file sono nostri, o ci sono o è rotto il tema.
*/
(function () {
  var B = window.WS_GSAP_BOOT || {};

  /* Shim minimale se lo stub in <head> mancasse (sezione rimossa, editor strano). */
  var API = window.WS_GSAP || (window.WS_GSAP = {
    v: null,
    editor: !!(window.Shopify && window.Shopify.designMode),
    _ok: false,
    _q: [],
    ready: function (fn) { if (typeof fn !== 'function') { return; } if (this._ok) { try { fn(window.gsap); } catch (e) {} } else { this._q.push(fn); } },
    _flush: function () { this._ok = true; var q = this._q.splice(0); for (var i = 0; i < q.length; i++) { try { q[i](window.gsap); } catch (e) {} } try { window.dispatchEvent(new CustomEvent('ws:gsap:ready')); } catch (e) {} },
    refresh: function () { if (window.ScrollTrigger) { window.ScrollTrigger.refresh(); } },
    smoother: function (o) { if (this.editor || typeof ScrollSmoother === 'undefined') { return null; } return ScrollSmoother.get() || ScrollSmoother.create(o || { smooth: 1, effects: true }); }
  });

  /* Registrazione ROBUSTA: solo ciò che esiste davvero. */
  function registerAll() {
    if (typeof gsap === 'undefined') { return false; }
    var names = B.globals || [], toRegister = [];
    for (var i = 0; i < names.length; i++) {
      var g = window[names[i]];
      if (typeof g !== 'undefined') { toRegister.push(g); }
    }
    if (toRegister.length) { gsap.registerPlugin.apply(gsap, toRegister); }
    return true;
  }

  /* Uccide gli ScrollTrigger i cui nodi non sono più nel DOM.
     Tipico dopo un shopify:section:load — l'equivalente esatto del
     ri-render di widget nell'editor Elementor. */
  function killDeadTriggers() {
    if (!window.ScrollTrigger) { return; }
    var all = ScrollTrigger.getAll();
    for (var i = 0; i < all.length; i++) {
      var t = all[i].trigger;
      if (t && !document.body.contains(t)) { all[i].kill(); }
    }
  }

  /* BRIDGE THEME EDITOR — sostituisce il bridge Elementor della v2.
     Nell'editor, a ogni sezione (ri)caricata o rimossa: cleanup + refresh,
     con debounce perché il merchant trascina e gli eventi arrivano a raffica. */
  function bridgeThemeEditor() {
    if (!API.editor) { return; }
    var pending;
    function bump() {
      if (!window.ScrollTrigger) { return; }
      clearTimeout(pending);
      pending = setTimeout(function () {
        killDeadTriggers();
        ScrollTrigger.refresh();
      }, 120);
    }
    document.addEventListener('shopify:section:load', bump);
    document.addEventListener('shopify:section:unload', bump);
    document.addEventListener('shopify:section:reorder', bump);
    document.addEventListener('shopify:block:select', bump);
  }

  function finish() {
    API.v = B.ver || null;
    bridgeThemeEditor();
    /* Posizioni ScrollTrigger corrette a webfont caricati
       (fondamentale con SplitText e titoli con font custom). */
    if (document.fonts && document.fonts.ready && window.ScrollTrigger) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
    /* Una volta sola, come da playbook §9.1. */
    if (window.ScrollTrigger && !window.__bscStConfigured) {
      window.__bscStConfigured = true;
      ScrollTrigger.config({ ignoreMobileResize: true });
    }
    API._flush();
  }

  if (registerAll()) {
    finish();
  } else if (window.console) {
    /* Se gsap non è definito, i file non sono in assets/ o hanno nome diverso.
       Non c'è failover: si guarda la Network tab. Le sezioni sopravvivono
       comunque, perché ognuna ha il suo guard (playbook §9.0.2 e §9.3). */
    console.error('[WS_GSAP] gsap non definito: verificare i file in assets/');
  }
})();
